// Configuration for the Home page

export const AOS_CONFIG = {
  duration: 800,
  easing: 'ease-out-cubic',
  once: true,
  offset: 60,
};

export const SEO = {
  title: 'OrbisDMC | Vietnam Destination Management Company',
  description:
    'A premium Vietnam DMC delivering custom itineraries, luxury stays, and closed-door access for travel partners and independent travellers.',
};

export const WHAT_WE_DO = {
  heading: 'Experiences We Create',
  items: [
    {
      id: 'corporate-travel',
      title: 'Corporate Travel',
      description:
        'Comprehensive travel management solutions designed to simplify business travel while enhancing efficiency, cost control and traveler experience.',
    },
    {
      id: 'mice',
      title: 'MICE',
      description:
        'End-to-end planning and execution of meetings, incentive programs, conferences, product launches, and corporate events across leading global destinations.',
    },
    {
      id: 'destination-weddings',
      title: 'Destination Weddings',
      description:
        'Curated destination wedding experiences that combine creativity, meticulous planning, and flawless execution to create celebrations that are truly unforgettable.',
    },
    {
      id: 'dmc',
      title: 'Destination Management',
      description:
        'Local expertise with global standards, providing destination services, logistics, contracting, excursions, transportation, and on-ground support for leisure and business travel.',
    },
    {
      id: 'b2b',
      title: 'B2B Travel Solutions',
      description:
        'Strategic partnerships with travel agencies, tour operators, and corporate clients, offering reliable products, destination expertise, and scalable travel solutions.',
    },
    {
      id: 'private-transport',
      title: 'Private Transport & Logistics',
      description:
        'Premium fleet of vehicles with professional drivers for seamless airport transfers, inter-city travel, and customised group transportation across all major destinations.',
    },
  ],
};
